// CSV-ÍRÓ — RFC 4180 szerint, Excel-kompatibilisen, formula-injection ellen védve.
//
// MIÉRT SAJÁT ÍRÓ ÉS MIÉRT ILYEN RÉSZLETESEN: a legacy CRM CSV-exportja (`app/Traits/Exporter.php`) három
// külön hibát vitt magával, és mind a három ADATVESZTÉSSEL vagy BIZTONSÁGI kockázattal járt:
//
//  1. **A sortörést `";"`-re cserélte** (`str_replace(["\r\n","\n"], '";"', $cell)`) — vagyis egy több-soros
//     cellából ÚJ OSZLOPOKAT csinált: a sor eltolódott, és a mögötte lévő mezők más oszlopba estek.
//     Itt a sortörés a mezőn BELÜL marad, idézőjelek között (ezt az RFC 4180 kifejezetten engedi).
//  2. **A beágyazott idézőjelet nem escape-elte** (`'"' . $cell . '"'`) — egy `36"-os TV` tartalom kettészelte
//     a mezőt. A szabály: a `"` a mezőben `""`-ra duplázódik.
//  3. **Nem volt UTF-8 BOM** — az Excel a magyar szöveget latin-1-ként olvasta („Ãrpád"). A BOM az egyetlen
//     hordozható jel, amiből az Excel felismeri az UTF-8-at.
//
// A NEGYEDIK dolog nem legacy-hiba, hanem iparági alap-védelem: **CSV FORMULA INJECTION**. Ha egy cella
// `=`, `+`, `-`, `@`, TAB vagy CR karakterrel kezdődik, az Excel/Sheets KÉPLETNEK olvassa — és mivel a
// tartalom felhasználói adat (ügyfél-név, jegy-leírás), egy `=HYPERLINK(...)` vagy `=cmd|...` cella a
// megnyitó kollégánál futhat le. Ezért az ilyen cellát egy aposztróffal prefixeljük (az OWASP bevett
// javaslata): az Excel szövegként kezeli, a tartalom pedig olvasható marad.

/** Egy cella lehetséges értéke — SZŰK típus szándékosan: egy objektum `String()`-je „[object Object]" lenne. */
export type CsvValue = string | number | boolean | null | undefined;

/** A mezőn belül idézőjelezést kényszerítő karakterek (RFC 4180: separator, idézőjel, sortörés). */
const NEEDS_QUOTING = /[",\r\n]/;
/** Képlet-kezdő karakterek — ezekre a táblázatkezelők kiértékelést indítanak. */
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

/**
 * Egy cella-érték → CSV-mező. A sorrend LOAD-BEARING: előbb a formula-guard (a prefix az ÉRTÉK része lesz),
 * utána az idézőjelezés — így az aposztróf is a mezőn belülre kerül.
 */
export function csvCell(value: CsvValue): string {
  if (value === null || value === undefined) return '';
  const raw = typeof value === 'string' ? value : String(value);
  if (raw === '') return '';
  const guarded = FORMULA_PREFIX.test(raw) ? `'${raw}` : raw;
  if (!NEEDS_QUOTING.test(guarded)) return guarded;
  return `"${guarded.replaceAll('"', '""')}"`;
}

/**
 * Fejléc + sorok → teljes CSV szöveg. A sorvég **CRLF** (az RFC 4180 ezt írja elő, és a Windows-Excel is ezt
 * várja), a fájl elején **UTF-8 BOM**. A visszatérés STRING — a `Blob`-ot a hívó gyártja (tesztelhetőség).
 */
export function toCsv(headers: string[], rows: CsvValue[][]): string {
  const lines = [headers.map(csvCell).join(','), ...rows.map((r) => r.map(csvCell).join(','))];
  // A BOM ESCAPE-elve (`\ufeff`) és nem literálként: a láthatatlan karakter a kódban felismerhetetlen.
  return `\ufeff${lines.join('\r\n')}`;
}
